import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'

type Variant = 'primary' | 'secondary' | 'ghost'
type Size = 'md' | 'lg'

const base =
  'group inline-flex items-center justify-center gap-1.5 rounded-[19px] font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2'

const variants: Record<Variant, string> = {
  primary: 'border shadow-sm hover:shadow-md',
  secondary: 'border border-border bg-background text-foreground hover:bg-muted',
  ghost: 'text-foreground hover:bg-muted',
}

const sizes: Record<Size, string> = {
  md: 'h-10 px-5 text-sm',
  lg: 'h-12 px-6 text-base',
}

export function CtaButton({
  href,
  children,
  variant = 'primary',
  size = 'md',
  arrow = false,
  external = false,
  className,
}: {
  href: string
  children: React.ReactNode
  variant?: Variant
  size?: Size
  arrow?: boolean
  external?: boolean
  className?: string
}) {
  const content = (
    <>
      {children}
      {arrow && (
        <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </>
  )
  
  const primaryStyles = variant === 'primary' ? {
    borderColor: '#eaeef5',
    backgroundColor: 'rgba(244, 246, 247, 0.88)',
    color: '#727272',
  } : {}
  
  const classes = cn(base, variants[variant], sizes[size], className)

  if (external) {
    return (
      <a href={href} className={classes} style={primaryStyles} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    )
  }
  return (
    <Link href={href} className={classes} style={primaryStyles}>
      {content}
    </Link>
  )
}
